export const ENABLE_ACTIVE = 'ENABLE_ACTIVE';
export const DISABLE_ACTIVE = 'DISABLE_ACTIVE';
export const UPDATE_CHART_ITEM = 'UPDATE_CHART_ITEM';
export const UPDATE_CHART_ITEM_CHARTLIST = 'UPDATE_CHART_ITEM_CHARTLIST'
export const UPDATE_CHART_ITEM_ONE = 'UPDATE_CHART_ITEM_ONE'
export const UPDATE_CHART_ITEM_CHARTLIST_ONE = 'UPDATE_CHART_ITEM_CHARTLIST_ONE'

export default {
    ENABLE_ACTIVE,
    DISABLE_ACTIVE,
    UPDATE_CHART_ITEM,
    UPDATE_CHART_ITEM_CHARTLIST,
    UPDATE_CHART_ITEM_ONE,
    UPDATE_CHART_ITEM_CHARTLIST_ONE
}